export const MODAL_FULLSCREEN_CLASS = 'background-shade-100'
export const MODAL_FULLSCREEN_STYLE = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 4,
  },
  content: {
    position: 'relative',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    padding: 0,
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    zIndex: 5,
    border: 'none',
    borderRadius: '0px',
    outline: 'none',
  },
}

export const MODAL_DEFAULT_CLASS =
  'background-shade-100 color-mode-elevated radius-normal shadow-hovering'
export const MODAL_DEFAULT_STYLE = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(39, 40, 43, 0.25)',
    overflowY: 'scroll',
    zIndex: 4,
  },
  content: {
    borderRadius: '4px',
    position: 'relative',
    padding: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    border: 'none',
    maxWidth: 1200,
    margin: '30px auto',
    WebkitOverflowScrolling: 'touch',
    overflow: 'visible',
    outline: 'none',
  },
}
